export default "__VITE_ASSET__1c3fad19__"